import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { MetalTypeModel } from '@domain/entities/setting.type';
import { MetalTypeServer } from '@domain/entities/setting.type';
import { SettingsGateway } from '@domain/gateway/settings-gateway';
import { PercentageServerModel } from '@domain/entities/setting.type';

@Injectable({
    providedIn: 'root',
})
export class SettingsService extends SettingsGateway {
    private parametersConfig = 'v1/products/attributes/terms';
    private percentageConfig = 'v1/products/price-levels/';

    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get users
     * @param params (Optional)
     * @returns Observable of users entity
     */
    readMetal(params?: HttpParams): Observable<MetalTypeServer[]> {
        return this._http.get<MetalTypeServer[]>(
            `${environment.host}${this.parametersConfig}`,
            {
                params,
            }
        );
    }

    /**
     * @description Get users
     * @param params (Optional)
     * @returns Observable of users entity
     */
    readPercentage(params?: HttpParams): Observable<PercentageServerModel> {
        return this._http.get<PercentageServerModel>(
            `${environment.host}${this.percentageConfig}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create users
     * @returns Observable of users entity
     */
    update(form: MetalTypeModel): Observable<{ msg: string }> {
        return this._http.post<{ msg: string }>(
            `${environment.host}${this.parametersConfig}`,
            form
        );
    }
}
